import React from "react"
import DrapeauSenegal from "image/DrapeauSenegal.jpg"
import InfoCard from "components/InfoCard/InfoCard"

function ATraiterCard({ client }) {
    const name = `${client.prenom} ${client.nom}`
    return (
        <InfoCard padding="2px" name= {name} Pays="Senegal" countryImage={DrapeauSenegal} preStayDate={client.created_at} />
    )
}

export default ATraiterCard